module.exports = __webpack_public_path__ + "static/img/banner2.6004712.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xf/banner2.jpg
// module id = UkoC
// module chunks = 1